const defaultState = () => ({
    showSuccess: false,
    categories: [],
    categoriesTree: [],
    subcategories_with_categories: [],
    categoriesList: null,
    categoriesPerPage: 3
});
export default defaultState;
